import http from '@/utils/http'
import Utils from '@/utils/default'

const sort = (sortBy, descending) => (sortBy && [
  descending ? '-' : '+',
  sortBy.trim()
].join('')) || ''

const fetchAll = filter => {
  const data = {
    ...filter,
    sort: sort(filter.sortBy, filter.descending)
  }
  return http()
    .get(`/users?${Utils.dataToUrlString(data)}`)
}

const fetch = ({ id }) => http()
  .get(`/users/${id}`)

const create = data => http()
  .post(`/users`, data)

const save = ({ id, data }) => http()
  .put(`/users/${id}`, data)

const lock = ({ id, reason }) => http()
  .post(`/users/${id}/lock`, { reason })

const unlock = ({ id, reason }) => http()
  .post(`/users/${id}/unlock`, { reason })

const risk = ({ id, reason }) => http()
  .post(`/users/${id}/risky`, { reason })

const unrisk = ({ id, reason }) => http()
  .post(`/users/${id}/unrisky`, { reason })

const exportUsers = () => http()
  .post(`/users/export`)

const importUsers = ({ file, email_notification }) => {
  const params = new FormData()
  params.append('file', file)
  params.append('email_notification', email_notification)
  return http()
    .post(`/users/import`, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
}

export default {
  fetchAll,
  fetch,
  lock,
  unlock,
  save,
  create,
  exportUsers,
  risk,
  unrisk,
  importUsers
}



// WEBPACK FOOTER //
// ./src/api/user.js